export class CreateBrokerageRequest {
  Environment: NonNullable<"LIVE" | "TEST" | "DEV" | "LOCAL" | "">;
  MachineName: string;
  ConveyanceID: number;
}
